import { render } from "./ExternalDevice.vue?vue&type=template&id=0771ff1b"
import script from "./ExternalDevice.vue?vue&type=script&lang=js"
export * from "./ExternalDevice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__